export default Garmin = {
    Map: {
        Event: {
            SWAP_MARKER_ID: 'swapmarkerid',
            ELEVATION_CHANGE: 'elevationChange',
            RESET_ROUTE: 'resetRoute'
        },
        Validator: {},
        Utils: {
            MEASURE_STATUTE: 'statute',
            RADIUS_KILOMETERS: 6371,
            RADIUS_MILES: 3959,
            FEET_PER_METER: 3.28083989501312,
            MARKER: 'marker-',
            POLYLINE: 'polyline-',
            LAP_MARKER_URL: '/modern/images/feature/courses/lap-marker-',
            SHADOW_URL: '/api/activity-search/style/explore/images/pin-shadow.png',
            METRIC: 'metric',
            GEO_OFFSET: 0.00007,
            GEO_BUFFER: 0.00007,
            BUSY_DIV_ID: 'loading-mask',
            MAP_STYLE_DEFAULT: 'default',
            MAP_STYLE_ROAD: 'road',
            MAP_STYLE_SATELLITE: 'satellite',
            MAP_STYLE_HYBRID: 'hybrid',
            MAP_STYLE_AUTO: 'auto',
            MAP_STYLE_TERRAIN: 'terrain',
            MAP_STYLE_BICYCLE: 'bicycle',
            MAP_STYLE_OSM: 'osm',
            PROVIDER_TYPE_HERE: 'here',
            PROVIDER_TYPE_GOOGLE: 'google',
            PROVIDER_TYPE_OSM: 'osm',
            PROVIDER_TYPE_NUMAP: 'numap',
            PROVIDER_TYPE_BAIDU: 'BAIDU_V_1_4',
            PROVIDER_TYPE_MOCK: 'mock',
            MAXIMUM_ELEVATION_SAMPLES: 512,
            MAXIMUM_ELEVATION_PATH_POINTS: 375,
            LINE_COLOR: [255, 0, 0],
            LINE_OPACITY: 0.8,
            LINE_WIDTH: 4,
            EVENT_MARKER_CHANGED: 'changed',
            EVENT_MOUSE_CLICK: 'click',
            EVENT_MOUSE_DBLCLICK: 'doubleclick',
            EVENT_MOUSE_DOWN: 'mousedown',
            EVENT_MOUSE_OUT: 'mouseout',
            EVENT_MOUSE_OVER: 'mouseover',
            EVENT_MOUSE_UP: 'mouseup',
            EVENT_MOUSE_WHEEL: 'mousewheel',
            EVENT_MOUSE_RIGHT_CLICK: 'rightclick',
            EVENT_MAP_VIEW_CHANGE_START: 'viewchangestart',
            EVENT_MAP_VIEW_CHANGE_END: 'viewchangeend',
            EVENT_MAP_ZOOM_CHANGED: 'zoomchanged',
            EVENT_MAP_IDLE: 'idle',
            EVENT_DRAG_START: 'dragstart',
            EVENT_DRAG_END: 'dragend',
            EVENT_DRAGGING: 'dragging',
            EVENT_TARGET_MAP: 'map',
            EVENT_TARGET_MARKER: 'marker',
            EVENT_TARGET_POLYLINE: 'polyline',
            EVENT_TOGGLE_HEATMAP_ITEMS: 'toggleHeatmapItems',
            EVENT_OSM_MAP_READY: 'osmMapReady',
            LAYER_POLYLINES: 'polylineLayer',
            LAYER_TERMINUS: 'terminusLayer',
            LAYER_MARKERS: 'markerLayer',
            LAYER_SEGMENTS: 'segmentsLayer',
            LAYER_SEGMENT: 'segmentLayer',
            LAYER_DISTANCE_CLOSE: 'distanceLayerClose',
            LAYER_DISTANCE_MEDIUM: 'distanceLayerMedium',
            LAYER_DISTANCE_FAR: 'distanceLayerFar',
            LAYER_DISTANCE_MAX: 'distanceLayerMax',
            heatmapPreferences: null,
            heatmapFolderDataList: null,
            heatmapRenderedTileDataList: {},
            activityType: ''
        }
    },
    Queue: {
        Constants: {
            GC_SYNC_URL: 'connectagent://launch',
            GC_SYNC_ID: '#notify-agent',
            DEVICE_IMG_LOCATION: '//static.garmincdn.com/apps/connect/image/devices'
        },

        NotificationWidgetQueueIds: {
            QUEUE_NOTIFICATION: '#notify-agent'
        },

        Events: {
            SEND_TO_DEVICE_FROM_QUEUE: 'SEND_TO_DEVICE_FROM_QUEUE',
            VIEW_PENDING_ITEMS: 'VIEW_PENDING_ITEMS',
            MESSAGE_SENT: 'MESSAGE_SENT',
            RETURN_TO_TRAINING_PLAN: 'return.to.trainingplanpageview'
        },

        MessageTypes: {
            ACTIVITIES: {
                id: 1,
                type: 'courses',
                name: 'activities'
            },
            COURSES: {
                id: 2,
                type: 'courses',
                name: 'courses'
            },
            WORKOUTS: {
                id: 3,
                type: 'workouts',
                name: 'workouts'
            },
            PR: {
                id: 4,
                type: 'personal-records',
                name: 'personal-records'
            },
            SCHEDULES: {
                id: 5,
                type: 'schedules',
                name: 'schedules'
            },
            SETTINGS: {
                id: 6,
                type: 'settings',
                name: 'settings'
            },
            ZONES: {
                id: 6,
                type: 'settings',
                name: 'zones'
            },
            GOALS: {
                id: 7,
                type: 'goals',
                name: 'goals'
            },
            SOFTWARE_UPDATE: {
                id: 8,
                type: 'software_update',
                name: 'software_update'
            },
            DEVICE_SETTINGS: {
                id: 9,
                type: 'device-settings',
                name: 'device-settings'
            },
            LANGUAGE_SETTINGS: {
                id: 10,
                type: 'language-settings',
                name: 'language-settings'
            },
            PROFILE: {
                id: 11,
                type: 'user-profile',
                name: 'user-profile'
            },
            SPORTS: {
                id: 12,
                type: 'sports',
                name: 'sports'
            },
            SEGMENT_LEADERS: {
                id: 14,
                type: 'segment-leaders',
                name: 'segment-leaders'
            }
        }
    }
};
